import { render, staticRenderFns } from "./deactivateModal.vue?vue&type=template&id=2b3860f9&scoped=true"
import script from "./deactivateModal.vue?vue&type=script&lang=js"
export * from "./deactivateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3860f9",
  null
  
)

export default component.exports